<p-checkbox
  [formControl]="formControlInput()"
  [binary]="true"
  [invalid]="formControlInput().invalid && formControlInput().touched"
  inputId="conditions"
/>
<label for="conditions" class="ml-2 text-[1rem]">I agree to Homey's <a class="underline" routerLink="/terms-and-conditions">Terms &
  Conditions</a>
  and
  acknowledge the <a class="underline" routerLink="/privacy-policy">Privacy Policy</a></label>
